import React from 'react';

import i18n from 'util/i18n';

import { SUBSTANCE_USE, SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT } from 'config/formSections/substanceUse';
import { ErrorCode } from '@redux/modules/application/reducers/error';
import Field from 'components/Form/Field';
import Textarea from 'components/Form/Textarea';
import Branch from 'components/Form/Branch';
import { SubstanceDrugsNegativeImpactModel } from 'forms/sections/substance/drugs/negativeImpact/types';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import DateRange from 'components/Form/DateRange';

const sectionConfig = {
  key: SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT.key,
  section: SUBSTANCE_USE.name,
  store: SUBSTANCE_USE.store,
  subsection: SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT.name,
  storeKey: SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT.storeKey,
};

export class DrugNegativeImpact extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
  }

  update = (values: Partial<SubstanceDrugsNegativeImpactModel>) => {
    this.props.onUpdate(this.storeKey, {
      HasNegativeImpact: this.props.HasNegativeImpact,
      NegativeImpactDates: this.props.NegativeImpactDates,
      NegativeImpactExplanation: this.props.NegativeImpactExplanation,
      ...values,
    });
  };

  updateHasNegativeImpact = (values: SubstanceDrugsNegativeImpactModel['HasNegativeImpact']) => {
    const additionalValues: Partial<SubstanceDrugsNegativeImpactModel> = {};
    if (values?.value === 'No') {
      additionalValues.NegativeImpactExplanation = {};
      additionalValues.NegativeImpactDates = {};
    }
    this.update({ ...additionalValues, HasNegativeImpact: values });
  };

  updateNegativeImpactExplanation = (values: SubstanceDrugsNegativeImpactModel['NegativeImpactExplanation']) => {
    this.update({ NegativeImpactExplanation: values });
  };

  updateNegativeImpactDates = (values: SubstanceDrugsNegativeImpactModel['NegativeImpactDates']) => {
    this.update({ NegativeImpactDates: values });
  };

  render() {
    return (
      <div
        className="section-content drug-ngeative-impact"
        data-section={SUBSTANCE_USE.key}
        data-subsection={SUBSTANCE_USE_DRUGS_NEGATIVE_IMPACT.key}
      >
        <h1 className="section-header">{i18n.t('substance.pvq.subsection.drugs.negativeImpact')}</h1>
        <Branch
          {...this.props.HasNegativeImpact}
          name="HasNegativeImpact"
          attribute="HasNegativeImpact"
          label={i18n.t('substance.pvq.drugs.heading.negativeImpact')}
          labelSize="h4"
          className="has-negative-impact"
          onError={this.props.onError}
          required={this.props.required}
          onUpdate={this.updateHasNegativeImpact}
          scrollIntoView={this.props.scrollIntoView}
        />
        {this.props.HasNegativeImpact?.value === 'Yes' && (
        <>
          <Field
            title={i18n.t('substance.pvq.drugs.negativeImpact.heading.impact')}
            attribute="NegativeImpactExplanation"
            scrollIntoView={this.props.scrollIntoView}
          >
            <Textarea
              {...this.props.NegativeImpactExplanation}
              name="NegativeImpactExplanation"
              attribute="NegativeImpactExplanation"
              className="negative-impact-explanation"
              onUpdate={this.updateNegativeImpactExplanation}
              onError={this.props.onError}
              required={this.props.required}
            />
          </Field>
          <Field
            attribute="NegativeImpactDates"
            title={i18n.t('substance.pvq.drugs.negativeImpact.heading.impactDates')}
            adjustFor="daterange"
            scrollIntoView={this.props.scrollIntoView}
          >
            <DateRange
              attribute="NegativeImpactDates"
              name="NegativeImpactDates"
              className="negative-impact-dates"
              {...this.props.NegativeImpactDates}
              minDateEqualTo
              onUpdate={this.updateNegativeImpactDates}
              onError={this.props.onError}
              required={this.props.required}
              hideFromDay
              hideToDay
            />
          </Field>
        </>
        )}
      </div>
    );
  }
}

DrugNegativeImpact.defaultProps = {
  onError: (value, arr: ErrorCode[]) => arr,
};

export default connectSubsection(DrugNegativeImpact, sectionConfig);
